import { Account } from "../../models/Account";
import { PlayerBadges, fantasyWinnerSeasons, isTopDonator, isVerifiedContent } from "../../services/BadgeService";
import { DonatorBadge } from "./DonatorBadge";
import { FantasyWinnerBadge } from "./FantasyWinnerBadge";
import { PremiumBadge } from "./PremiumBadge";
import { TopDonatorBadge } from "./TopDonatorBadge";
import { VerifiedBadge } from "./VerifiedBadge";

type AccountBadgesProps = {
    account: Account | null;
    badges: PlayerBadges | null;
};

/**
 * Every badge a player has earned, in the site's established order.
 *
 * The two sources are separate on purpose: `premium`/`donator` are flags on the accounts table and
 * arrive on the account itself, while top-donator and verified-creator are rows in `player_badges`
 * and only come from {@link useBadges}. `badges` may still be null on a cold cache — the account
 * flags render regardless, and the other two appear when the shared fetch lands.
 */
export const AccountBadges = ({ account, badges }: AccountBadgesProps) => {
    if (!account) return null;

    return (
        <>
            {badges && fantasyWinnerSeasons(account.steamID, badges).map((season) => (
                <FantasyWinnerBadge key={season} season={season} />
            ))}
            {badges && isTopDonator(account.steamID, badges) && <TopDonatorBadge />}
            {badges && isVerifiedContent(account.steamID, badges) && <VerifiedBadge />}
            {account.premium && <PremiumBadge />}
            {account.donator && <DonatorBadge />}
        </>
    );
};
